import React from "react";
import ArenkoThemeProvider from "@arenko-group/arenko-ui/dist/theme/ArenkoThemeProvider";
import CubeProvider from "./CubeProvider";
import LazyRouterProvider from "./LazyRouterProvider";

const NimbusGlobalProvider = () => {
  return (
    <CubeProvider>
      <ArenkoThemeProvider brandName="nimbusApp" withContainer={false}>
        <LazyRouterProvider />
      </ArenkoThemeProvider>
    </CubeProvider>
  );
};

export default NimbusGlobalProvider;
